export function fetchAddonOptions(serviceid) {
  return fetch(
    process.env.REACT_APP_BASE_API + 'order/apis/getListAddons.php?serviceid=' + serviceid
  ).then((response) => {
    const data = response.json();
    return data.then((result) => {
      if (result.status === 'error') {
        const error = new Error(result.message || 'Failed to fetch addon options');
        Object.assign(error, result);
        throw error;
      }
      return result;
    });
  })
}

export function fetchClientServices() {
  return fetch(
    process.env.REACT_APP_BASE_API + 'order/apis/getListAddons.php'
  ).then((response) => response.json())
}

// Helper function to normalize billing cycle for pricing lookup
export function normalizeBillingCycle(cycle) {
  const normalizedCycle = String(cycle).toLowerCase().trim();
  
  const cycleMap = {
    'monthly': 'monthly',
    'quarterly': 'quarterly',
    'semiannually': 'semiannually',
    'semi-annually': 'semiannually',
    'annually': 'annually',
    'biennially': 'biennially',
    'triennially': 'triennially'
  };
  return cycleMap[normalizedCycle] || normalizedCycle;
}

// Helper function to get addon price based on billing cycle
export function getAddonPrice(addon, billingCycle) {
  if (!addon?.pricing?.IDR) return 0;
  
  const normalizedCycle = normalizeBillingCycle(billingCycle);
  const pricing = addon.pricing.IDR;
  
  return parseFloat(pricing[normalizedCycle] || 0);
}

// Helper function to get billing cycle options for addon
export function getAddonBillingCycleOptions(addon) {
  if (!addon?.pricing?.IDR) return [];
  
  const pricing = addon.pricing.IDR;
  const cycles = [];
  
  Object.keys(pricing).forEach(cycle => {
    if (cycle !== 'prefix' && cycle !== 'suffix' &&
      cycle !== 'msetupfee' && cycle !== 'qsetupfee' &&
      cycle !== 'ssetupfee' && cycle !== 'asetupfee' &&
      cycle !== 'bsetupfee' && cycle !== 'tsetupfee') {
      const price = parseFloat(pricing[cycle]);
      if (price > 0) {
        cycles.push({
          cycle: cycle,
          price: price,
          displayName: cycle.charAt(0).toUpperCase() + cycle.slice(1)
        });
      }
    }
  });
  
  return cycles;
}
